import React from "react"
import { Image } from "./Images"
import { useStaticQuery, graphql } from "gatsby"

export const Boulder1 = () => {
  const data = useStaticQuery(graphql`
    query {
      placeholderImage: file(relativePath: { eq: "boulder-1.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 990) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    }
  `)
  return <Image data={data} />
}

export default Boulder1
